export default "__VITE_ASSET__BIjahoy8__"